import { render, staticRenderFns } from "./IncomingCalls.vue?vue&type=template&id=30c82dce&scoped=true"
import script from "./IncomingCalls.vue?vue&type=script&lang=js"
export * from "./IncomingCalls.vue?vue&type=script&lang=js"
import style0 from "./IncomingCalls.vue?vue&type=style&index=0&id=30c82dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c82dce",
  null
  
)

export default component.exports